module.exports = __webpack_public_path__ + "img/util-tab-3.8836cda7.svg";